import React, { Suspense, useMemo } from "react";
import { Button, Box, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

const LazyBlobProvider = React.lazy(() => import("@react-pdf/renderer").then(module => ({ default: module.BlobProvider })));

const PDFViewerWithDownload = ({ document, width = "100%", height = "600px", fileName = "document.pdf" }) => {
  const memoizedDoc = useMemo(() => document, [document]);

  return (
    <Suspense fallback={<CircularProgress />}>
      <LazyBlobProvider document={memoizedDoc}>
        {({ blob, url, loading, error }) => {
          if (loading) return <CircularProgress />;
          if (error) return <div>Error generating PDF: {error.message}</div>;
          return (
            <Box>
              <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = url;
                  link.download = fileName;
                  link.click();
                }}
                sx={{ mb: 1 }}
              >
                Download PDF
              </Button>
              <iframe src={url} width={width} height={height} style={{ border: "none" }} />
            </Box>
          );
        }}
      </LazyBlobProvider>
    </Suspense>
  );
};

export default PDFViewerWithDownload;
